import { Pipe, PipeTransform } from '@angular/core';
import { UserLike } from '../services/avatar.service';

export const avatarType = (user: UserLike): 'image' | 'svg' => {
  if (user?.avatar_url && !user.avatar_url.includes('img.clerk.com')) return 'image';
  return 'svg';
};

@Pipe({
  name: 'avatarType',
  standalone: true,
  pure: true,
})
export class AvatarTypePipe implements PipeTransform {
  transform(user: UserLike): 'image' | 'svg' {
    return avatarType(user);
  }
}
